<template>
  <div class="auth-wrapper d-flex align-items-center justify-content-center">
    <div class="auth-card shadow-lg animate__animated animate__fadeIn">
      <div class="brand-header text-center mb-4">
        <div class="logo-circle mx-auto mb-2">
          <img src="../assets/task logo.png" alt="logo" />
        </div>
        <h3 class="fw-bold m-0">Tasks<span class="text-primary">App</span></h3>
      </div>

      <div class="auth-content">
        <h4 class="text-center fw-bold mb-4">
          {{ isLogin ? "Welcome Back!" : "Create Account" }}
        </h4>

        <form @submit.prevent="handleSubmit" class="auth-form">
          <div class="form-floating mb-3" v-if="!isLogin">
            <input
              type="text"
              v-model="username"
              class="form-control"
              id="username"
              placeholder="Username"
              required
            />
            <label for="username"
              ><i class="fas fa-user me-2"></i>Username</label
            >
          </div>

          <div class="form-floating mb-3">
            <input
              type="email"
              v-model="email"
              class="form-control"
              id="email"
              placeholder="name@example.com"
              required
            />
            <label for="email"
              ><i class="fas fa-envelope me-2"></i>Email address</label
            >
          </div>

          <div class="form-floating mb-4 position-relative">
            <input
              :type="isShowed ? 'text' : 'password'"
              v-model="password"
              class="form-control"
              id="password"
              placeholder="Password"
              required
            />
            <label for="password"
              ><i class="fas fa-lock me-2"></i>Password</label
            >
            <span class="password-toggle" @click="TogglePassword">
              <i :class="isShowed ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
            </span>
          </div>

          <button
            type="submit"
            class="btn btn-primary w-100 py-3 fw-bold shadow-sm"
            :disabled="loading"
          >
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm me-2"
            ></span>
            {{ loading ? "Processing..." : isLogin ? "Login" : "Register Now" }}
          </button>
        </form>

        <div class="text-center mt-4">
          <p class="text-muted small">
            {{
              isLogin ? "Don't have an account?" : "Already have an account?"
            }}
            <a
              href="javascript:void(0)"
              @click="toggleAuth"
              class="text-primary fw-bold text-decoration-none ms-1"
            >
              {{ isLogin ? "Sign Up" : "Login" }}
            </a>
          </p>
        </div>

        <div
          v-if="error"
          class="alert alert-danger-custom mt-3 animate__animated animate__shakeX"
        >
          <i class="fas fa-exclamation-circle me-2"></i> {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { usersService } from "@/services/userService";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      email: "",
      password: "",
      username: "",
      error: null,
      isLogin: true,
      loading: false,
      isShowed: false,
    };
  },

  methods: {
    toggleAuth() {
      this.isLogin = !this.isLogin;
      this.error = null;
    },

    async handleSubmit() {
      this.error = null;
      this.loading = true;

      try {
        if (this.isLogin) {
          // --- LOGIN LOGIC ---
          const data = await usersService.login({
            email: this.email,
            password: this.password,
          });

          // Save token and user info
          localStorage.setItem("token", data.token);
          localStorage.setItem("user", JSON.stringify(data.user));
          this.$router.push("/dashboard");
        } else {
          // --- SIGNUP LOGIC ---
          if (!this.username || this.username.trim().length < 3) {
            Swal.fire({
              icon: "warning",
              title: "Weak username",
              text: "the password must be at least 3 characters long.",
              confirmButtonColor: "#6366f1",
            });
            this.loading = false;
            return;
          }

          if (this.password && this.password.length < 6) {
            Swal.fire({
              icon: "warning",
              title: "Weak Password",
              text: "For your security, the password must be at least 6 characters long.",
              confirmButtonColor: "#6366f1",
            });
            this.loading = false;
            return;
          }
          await usersService.signup({
            username: this.username,
            email: this.email,
            password: this.password,
          });

          // Store email temporarily to use it in verification page
          localStorage.setItem("temp_email", this.email);

          // Redirect to verification code page
          this.$router.push("/verify-email");
        }
      } catch (err) {
        // Handle Backend Errors
        if (err.response && err.response.data) {
          // Displays the error message coming from Express
          this.error =
            typeof err.response.data === "string"
              ? err.response.data
              : err.response.data.message || "An error occurred";
        } else {
          this.error = "Server is unreachable. Please try again later.";
        }
      } finally {
        this.loading = false;
      }
    },

    TogglePassword() {
      if (this.password !== "") {
        this.isShowed = !this.isShowed;
        // this.$refs.password.type = this.isShowed ? "text" : "password";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
}

.auth-card {
  background: #ffffff;
  width: 100%;
  max-width: 450px;
  border-radius: 20px;
  padding: 40px;
  border: none;

  .logo-circle {
    width: 60px;
    height: 60px;
    background: #fff;
    border-radius: 15px;
    padding: 10px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.form-floating {
  input {
    border: 1px solid #e1e5ee;
    border-radius: 12px;
    height: 60px;
    &:focus {
      box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.1);
      border-color: #0d6efd;
    }
  }
  label {
    color: #6c757d;
  }
}

.password-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #adb5bd;
  z-index: 10;
  transition: color 0.3s;
  &:hover {
    color: #0d6efd;
  }
}

.btn-primary {
  border-radius: 12px;
  background: #0d6efd;
  transition: all 0.3s ease;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(13, 110, 253, 0.3);
  }
}

.alert-danger-custom {
  background-color: #fff5f5;
  border: 1px solid #feb2b2;
  color: #c53030;
  padding: 12px;
  border-radius: 10px;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
}

/* Animations using animate.css logic */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate__fadeIn {
  animation: fadeIn 0.6s ease-out;
}
</style>
